export const GenieAcsStatusBadgeComponent = ({ status }) => {
    const config = {
        online: {
            bg: "bg-emerald-500/12",
            text: "text-emerald-400",
            border: "border-emerald-500/20",
            dot: "bg-emerald-400",
        },
        offline: {
            bg: "bg-red-500/12",
            text: "text-red-400",
            border: "border-red-500/20",
            dot: "bg-red-400",
        },
        rebooting: {
            bg: "bg-amber-500/12",
            text: "text-amber-400",
            border: "border-amber-500/20",
            dot: "bg-amber-400",
        },
    };

    const c = config[status?.toLowerCase()] || config.offline;

    return (
        <span
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold tracking-wide ${c.bg} ${c.text} border ${c.border}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
            {status || "-"}
        </span>
    )
}